import InputSpecial from './Input';

export interface BaseInputProps {
  dataPrefix?: string;
  value: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  maxLength?: number;
  error?: boolean;
  onChange: (value: string, oldValue?: string) => void;
  setError?: (error: boolean) => void;
}

export * from './Input';
export * from './Textarea';

export default InputSpecial;
